const formatDate = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", { 
    dateStyle: "medium", 
    timeStyle: "short" 
  });
};

export default formatDate;